import React from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import EmailInput from '../../components/Inputs/EmailInput';
import TextInput from '../../components/Inputs/TextInput';
import ReactSelect from '../../components/Inputs/ReactSelect';
import { COUNTRIES } from '../../helpers/selectOptions';
import { PARTNER_TYPES } from '../../config';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useUsers from '../../store/users/usersContext';
import DateInput from '../../components/Inputs/DateInput';

function AddPartner() {
  
  const history = useHistory();

  const {
    invitePartner
  } = useUsers();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [newPartner, _setNewPartner] = React.useState({
    email: null,
    country: null,
    city: null,
    address: null,
    postalCode: null,
    firstName: null,
    lastName: null,
    type: null,
    mobile: null,
    dateOfBirth: null
  });

  const setNewPartner = (newVal) => _setNewPartner({...newPartner, ...newVal});

  const countryOptions = [];
  if (!countryOptions.length) COUNTRIES.forEach(country => {
    countryOptions.push({
      value: country,
      label: country
    })
  });
  
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  const handleCreate = () => {
    let element;
    if (!validateEmail(newPartner.email)) {
    element = document.getElementById('email');
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'email',
        msg: "Please enter a valid email."
      });
    }
    if (newPartner.firstName === '' || newPartner.firstName === null) {
      element = document.getElementById('firstName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      
      return setFormError({
        field: 'firstName',
        msg: "Please enter a first name."
      });
    }
    if (newPartner.lastName === '' || newPartner.lastName === null) {
      element = document.getElementById('lastName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'lastName',
        msg: "Please enter a last name."
      });
    }
    if (newPartner.dateOfBirth === '' || newPartner.dateOfBirth === null) {
      element = document.getElementById('dateOfBirth');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'dateOfBirth',
        msg: "Please enter a date of birth."
      });
    }
    if (newPartner.type === '' || newPartner.type === null ) {
      element = document.getElementById('type');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'type',
        msg: "Please enter a partner type."
      });
    } 
    if (newPartner.country === '' || newPartner.country === null ) {
      return setFormError({
        field: 'country',
        msg: "Please enter the partner's country."
      });
    }
    if (newPartner.city=== '' || newPartner.city === null ) {
      return setFormError({
        field: 'city',
        msg: "Please enter the partner's city."
      });
    }
    if (newPartner.address=== '' || newPartner.address === null ) {
      return setFormError({
        field: 'address',
        msg: "Please enter the partner's address."
      });
    }
    if (newPartner.postalCode=== '' || newPartner.postalCode === null ) {
      return setFormError({
        field: 'postalCode',
        msg: "Please enter the partner's postal code."
      });
    }
    if (newPartner.mobile=== '' || newPartner.mobile === null ) {
      return setFormError({
        field: 'mobile',
        msg: "Please enter the partner's mobile number."
      });
    }
    invitePartner(newPartner).then(() => {
      history.push('/manage-partners');
    });
  }


  const partnerTypeOptions = [];
  if (!partnerTypeOptions.length) PARTNER_TYPES.map(type => (
    partnerTypeOptions.push({
      label: type,
      value: type
    })
  ));
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Personal Information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <EmailInput id='email' horizontal label='Email*'  inputClass='col-span-3' data={newPartner.email} onChange={(e) => setNewPartner({email: e.target.value})} />
          {formError.field === 'email' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='firstName' label='First name*' inputClass='col-span-3' /* value={newPartner.firstName} */ onChange={(e) => setNewPartner({firstName: e.target.value})}/>
          {formError.field === 'firstName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='lastName' label='Last name*' inputClass='col-span-3' value={newPartner.lastName} onChange={(e) => setNewPartner({lastName: e.target.value})}/>
          {formError.field === 'lastName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <DateInput id='dateOfBirth' label='Date of birth*' inputClass='col-span-3' data={newPartner.dateOfBirth} onChange={(e) => setNewPartner({dateOfBirth: e.target.value})} />
          {formError.field === 'dateOfBirth' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <ReactSelect id='type' label='Partner type*' options={partnerTypeOptions} value={newPartner.type} inputClass='col-span-3' onChange={(e) => setNewPartner({ type: e.value })} /> 
          {formError.field === 'type' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className="bg-white rounded shadow py-12 px-10 mt-6">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Contact details</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>  
          <ReactSelect label='Country*' options={countryOptions} value={newPartner.country} inputClass='col-span-3' onChange={(e) => setNewPartner({ country: e.value })} /> 
          {formError.field === 'country' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='City*' data={newPartner.city} onChange={(e) => setNewPartner({city: e.target.value})} />
          {formError.field === 'city' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Address*' data={newPartner.address} onChange={(e) => setNewPartner({address: e.target.value})} />
          {formError.field === 'address' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Postal code*' data={newPartner.postalCode} onChange={(e) => setNewPartner({postalCode: e.target.value})} />
          {formError.field === 'postalCode' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Mobile*' data={newPartner.mobile} onChange={(e) => setNewPartner({mobile: e.target.value})} />
          {formError.field === 'mobile' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.push('/manage-partners')} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddPartner
